import { HTMLAttributes } from 'react'

import Boy from './Boy'
import Calendar from './Calendar'
import Close from './Close'
import GenderBoy from './GenderBoy'
import GenderChooseBoy from './GenderChooseBoy'
import GenderChooseGirl from './GenderChooseGirl'
import GenderGirl from './GenderGirl'
import Girl from './Girl'
import Info from './Info'
import Kebab from './Kebab'
import Save from './Save'
import Share from './Share'
import Warning from './Warning'

export type IconProps = {
  size?: number
  color?: string
  onClick?: () => void
} & HTMLAttributes<HTMLOrSVGElement>

export const Icons = {
  Boy,
  Calendar,
  GenderChooseBoy,
  GenderChooseGirl,
  GenderBoy,
  GenderGirl,
  Girl,
  Kebab,
  Share,
  Save,
  Warning,
  Close,
  Info,
}
